import HyperDX from "@hyperdx/browser";

const setupOTelSDK = () => {

  HyperDX.init({
    // apiKey: 'YOUR_INGESTION_API_KEY',
    tracePropagationTargets: [/localhost/i, /stg-cultivateapi.maple.comcast.net/i, /cultivateapi.maple.comcast.net/i], // Set to link traces from frontend to backend requests
    consoleCapture: false, // Capture console logs (default false)
    advancedNetworkCapture: false, // Capture full HTTP request/response headers and bodies (default false)
    service: 'maple-ui-react',
    url: window.REACT_APP_TRACE_ENDPOINT || "https://stg-cultivate-otel-collector.maple.comcast.net"
  });
};

const setHyperDXAttributes = (userDetails, userRoles) => {
  HyperDX.setGlobalAttributes({
    "userId": userDetails.user_id,
    "userName": userDetails.name,
    "userEmail": userDetails.email,
    "userRoles": userRoles.join(", ")
  });
}

export { setupOTelSDK, setHyperDXAttributes };